import { gql } from "@apollo/client";
import { DefaultFailureTypesIds, END_OF_SHIFT_FAILURE_CODE_NAME, OPERATOR_EXCEPTIONS } from "constants/constants";

export const getClusterData = gql`
    query getClusterData($cluster_id: Int!) {
        cluster(where: { cluster_id: { _eq: $cluster_id } }) {
            cluster_id
            name
            cluster_code
            mill_id
            mill {
                mill_id
                dedicated_localserver
                mqtt_broker_settings {
                    allow_anonymous
                    host
                    name
                    password
                    user
                    id
                }
            }
            machine_centers(where: { disabled_at: { _is_null: true }, deleted_at: { _is_null: true } }, order_by: [{ order_cluster: asc_nulls_last }, { created_at: asc }]) {
                machine_center_id
                downtime_method_capture_id
                name
                hmi_code
                plc_address
                minimum_downtime
                downtime_trigger_threshold
                is_bottleneck
                cluster {
                    inactivity_time_limit
                    inactivity_alert_delay
                }
                areas(
                    where: {
                        disabled_at: { _is_null: true }
                        functional_locations: {
                            disabled_at: { _is_null: true }
                            location_specific_functional_location_failure_codes: {
                                functional_location_id: { _gte: 0 }
                                failure_code: { deleted_at: { _is_null: true }, failure_type: { deleted_at: { _is_null: true } } }
                            }
                        }
                    }
                    order_by: [{ order: asc_nulls_last }, { created_at: asc }]
                ) {
                    area_id
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                    functional_locations(
                        where: {
                            disabled_at: { _is_null: true }
                            location_specific_functional_location_failure_codes: {
                                functional_location_id: { _gte: 0 },
                                failure_code: { deleted_at: { _is_null: true }, failure_type: { deleted_at: { _is_null: true } } }
                            }
                        }
                        order_by: [{ order: asc_nulls_last }, { created_at: asc }]
                    ) {
                        functional_location_id
                        translation {
                            id
                            translation_names {
                                name
                                language_id
                            }
                        }
                        location_specific_functional_location_failure_codes(
                            where: { 
                                failure_code: { 
                                    primary_code_id: { _is_null: true }, 
                                    deleted_at: { _is_null: true }, 
                                    failure_type: { deleted_at: { _is_null: true } } 
                                }
                            }
                        ) {
                            failure_code_id
                        }
                    }
                }
                users(where: { _and: [{ is_enabled: { _eq: true } }, { user: { is_enabled: { _eq: true } } }] }) {
                    user {
                        user_id
                        first_name
                        last_name
                        media {
                            media_id
                            media_url
                        }
                    }
                }
                production_line {
                    production_line_shifts(where: { disabled_at: { _is_null: true } }, limit: 1) {
                        shift_id
                    }
                    mill {
                        mill_id
                        cluster_enabled
                        mill_data {
                            timezone
                        }
                        country {
                            id
                            code
                            numeric_code
                        }
                        corporate {
                            country {
                                id
                                code
                                numeric_code
                            }
                        }
                        mqtt_broker_settings {
                            allow_anonymous
                            host
                            name
                            password
                            user
                            id
                        }
                    }
                }
                non_location_specific_failure_codes: non_location_specific_machine_center_failure_codes(
                    where: { 
                        failure_code: { 
                            primary_code_id: { _is_null: true }, 
                            deleted_at: { _is_null: true }, 
                            failure_type: { deleted_at: { _is_null: true } } 
                        }
                    }
                ) {
                    failure_code_id
                }
            }
            user_clusters(where: { _and: [{ is_enabled: { _eq: true } }, { user: { is_enabled: { _eq: true } } }] }) {
                user {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                    }
                }
            }
        }
        failure_type(
            where: {
                deleted_at: { _is_null: true },
                _or: [
                    {
                        failure_codes: {
                            deleted_at: { _is_null: true },
                            non_location_specific_machine_center_failure_codes: {
                                machine_center: {
                                    cluster_id: { _eq: $cluster_id }
                                    deleted_at: { _is_null: true }
                                    disabled_at: { _is_null: true }
                                }
                            }
                        }
                    }
                    {
                        failure_codes: {
                            deleted_at: { _is_null: true },
                            location_specific_functional_location_failure_codes: {
                                functional_location: {
                                    disabled_at: { _is_null: true }
                                    deleted_at: { _is_null: true }
                                    area: {
                                        disabled_at: { _is_null: true }
                                        deleted_at: { _is_null: true }
                                        machine_center: {
                                            cluster_id: { _eq: $cluster_id }
                                            disabled_at: { _is_null: true }
                                            deleted_at: { _is_null: true }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    { failure_type_id: { _eq: ${DefaultFailureTypesIds.BREAK_END_OF_SHIFT} } }
                ]
            }
        ) {
            failure_type_id
            name
            color_code
            is_location_specific
            corporate_id
            code
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    name
                }
                translated_name
            }
            failure_codes(where: {
                        deleted_at: { _is_null: true },
                        _and: [
                            { primary_code_id: { _is_null: true } }
                            {
                                _or: [
                                    {
                                        non_location_specific_machine_center_failure_codes: {
                                            machine_center: {
                                                cluster_id: { _eq: $cluster_id }
                                                deleted_at: { _is_null: true }
                                                disabled_at: { _is_null: true }
                                            }
                                        }
                                    }
                                    {
                                        location_specific_functional_location_failure_codes: {
                                            functional_location: {
                                                disabled_at: { _is_null: true }
                                                deleted_at: { _is_null: true }
                                                area: {
                                                    disabled_at: { _is_null: true }
                                                    deleted_at: { _is_null: true }
                                                    machine_center: {
                                                        cluster_id: { _eq: $cluster_id }
                                                        disabled_at: { _is_null: true }
                                                        deleted_at: { _is_null: true }
                                                    }
                                                }
                                            }
                                        }
                                    }     
                                    {
                                        code: { _eq: ${END_OF_SHIFT_FAILURE_CODE_NAME} }
                                    }
                                ]
                            }
                        ]
                    }) {
                failure_code_id
                name
                primary_code_id
                corporate_id
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
        no_operator_details: user(where: {code: {_eq: ${OPERATOR_EXCEPTIONS.NO_OPERATOR}}}) {
            user_id
        }
    }
`;
